@if (customer && project) {
    <div class="container mt-3">
        <div class="row align-items-baseline">
            <div class="col">
                <h1>{{ Utils.isDrillingRoute(route) ? 'Booropdracht' : 'Project' }} beheren</h1>
                <h2>{{ customer.name }}</h2>
            </div>
        </div>

        <div class="row mt-3">
            <div class="col-24 col-lg-12">
                <section class="border rounded p-3 mb-3">
                    <h5>Projectgegevens</h5>
                    <app-customer-project-form
                        #projectForm
                        [customer]="customer"
                        [project]="project"
                        (saved)="close($event)" />

                    <div class="d-flex justify-content-between mt-4">
                        <button (click)="delete()" color="warn" mat-button type="button">Project verwijderen</button>
                        <button
                            (click)="projectForm.save()"
                            [disabled]="projectForm.saving"
                            color="primary"
                            mat-raised-button
                            type="button">
                            Opslaan
                        </button>
                    </div>
                </section>
            </div>

            <div class="col-24 col-lg-12">
                <section class="border rounded p-3 mb-3">
                    <div class="d-flex justify-content-between align-items-baseline">
                        <h5>Projectleden</h5>
                        @if (revoked.length) {
                            <mat-checkbox [(ngModel)]="showRevoked" [ngModelOptions]="{ standalone: true }">
                                <small>Toon verwijderd</small>
                            </mat-checkbox>
                        }
                    </div>

                    @for (user of active; track user.id) {
                        <ng-container *ngTemplateOutlet="memberRow; context: { user: user }"></ng-container>
                    } @empty {
                        <p class="mb-0"><small>Nog niemand heeft toegang tot dit project.</small></p>
                    }

                    @if (showRevoked) {
                        @for (user of revoked; track user.id) {
                            <ng-container
                                *ngTemplateOutlet="memberRow; context: { user: user, removed: true }"></ng-container>
                        }
                    }

                    <ng-template #memberRow let-user="user" let-removed="removed">
                        <div
                            class="d-flex justify-content-between align-items-center mb-2"
                            [class.text-muted]="removed">
                            <div>
                                <strong>{{ user.name }}</strong>
                                <small class="ms-2">{{ user.email }}</small>
                                <br />
                                <div class="ps-3">
                                    <small>
                                        <i class="fas fa-user-plus me-1"></i>
                                        {{ user.accepted_at | date: 'EEE d MMM y' }}
                                        door {{ user?.accepted_by_name || 'systeem' }}
                                        @if (removed) {
                                            <br /><i class="fas fa-trash me-1"></i>
                                            {{ user.deleted_at | date: 'EEE d MMM y' }}
                                            @if (user.deleted_by_name) {
                                                door {{ user.deleted_by_name }}
                                            }
                                        }
                                        @if (user.latest_access_at) {
                                            <br /><i class="fas fa-eye me-1" title="Laatst bekeken"></i>
                                            {{ user.latest_access_at | date: 'EEE d MMM y' }}
                                        }
                                    </small>
                                </div>
                            </div>
                            <div class="flex-fill"></div>
                            @if (!removed) {
                                <div
                                    class="d-flex align-items-center pe-3"
                                    [matTooltipDisabled]="projectForm.fc.email.value"
                                    matTooltip="E-mailupdates zijn uitgeschakeld voor dit project">
                                    <mat-checkbox
                                        [disabled]="!projectForm.fc.email.value"
                                        [checked]="user.email_notifications"
                                        (change)="toggleEmailNotifications(user)"
                                        class="mx-2">
                                        E-mailupdates
                                    </mat-checkbox>
                                </div>
                                <div>
                                    <i class="fas fa-trash pointer" (click)="revokeAccess(user)"></i>
                                </div>
                            }
                        </div>
                    </ng-template>

                    @if (grantable.length) {
                        <div class="d-flex align-items-center mt-3">
                            <ng-select
                                [(ngModel)]="addUserIds"
                                [ngModelOptions]="{ standalone: true }"
                                [items]="grantable"
                                [multiple]="true"
                                [closeOnSelect]="false"
                                bindLabel="name"
                                bindValue="id"
                                class="flex-grow-1 me-2"
                                placeholder="Personen toegang geven">
                            </ng-select>
                            <button
                                (click)="addAccess()"
                                [disabled]="!addUserIds.length"
                                color="primary"
                                mat-raised-button
                                type="button">
                                Toevoegen
                            </button>
                        </div>
                    }
                </section>
                <section class="border rounded p-3 mb-3">
                    <h5>Toegangsverzoeken</h5>
                    @for (user of pending; track user.id) {
                        <div class="d-flex justify-content-between align-items-center mb-2">
                            <div>
                                <strong>{{ user.name }}</strong
                                ><br />
                                <small>Aangevraagd op {{ user.requested_at | date: 'EEE d MMM y H:mm' }}</small>
                            </div>
                            <div class="d-flex align-items-center">
                                <button (click)="acceptRequest(user)" color="primary" mat-raised-button type="button">
                                    Accepteren
                                </button>
                                <i class="fas fa-trash pointer ms-3" (click)="rejectRequest(user)"></i>
                            </div>
                        </div>
                    } @empty {
                        <p class="mb-0"><small>Geen openstaande toegangsverzoeken.</small></p>
                    }
                </section>
            </div>
        </div>
    </div>
}
